<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="primary" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-solicitudes-modificacion"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :headerHeight="48"
      :floatingFiltersHeight="38" />
  </div>
</template>

<script>
import listadoAgGridMixin from '@/views/pagos/mixins/listado-ag-grid.mixin';
// import { cellRendererNumeroRegistro } from '@/views/pagos/utils/funciones';
import { cellRendererEstadoSolicitud, formatearFechaHoraBolivia,cellRendererNumeroRegistro, getRevisor } from '../../utils/funciones';

export default {
  name: 'ListadoSolicitudesModificacionCalificacion',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      defaultColDef: {
        sortable: false,
        filter: true,
        floatingFilter: true,
        resizable: true,
        suppressMenu: true,
        autoHeight: true,
        wrapText: true,
      },
      columnDefs: [
        {
          headerName: '#',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 70,
          maxWidth: 70,
        },
        {
          headerName: 'Programa / Sede / Módulo',
          cellRenderer: (params) => {
            const programa = params.data?.programa;
            if (!programa) return '';
            const sede = programa.sedeNombre || 'Sin sede';
            const codigo = programa.codigo || '';
            const nombre = programa.nombreCompuesto || '';

            const modulo = params.data?.programaModulo;
            const moduloNumero = modulo?.numero || '';
            const moduloNombre = modulo?.moduloNombre || '';

            return `
              <div class="d-flex flex-column py-1 w-100" style="line-height: 1.4;">
                <div class="text-body-2 font-weight-bold" style="color: #1e293b; font-size: 0.85rem; white-space: normal; word-break: break-word;" title="${nombre}">
                  ${nombre}
                </div>
                <div class="d-flex align-center flex-wrap mt-1" style="gap: 6px;">
                  <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small primary primary--text body-2 font-weight-bold" style="height: 18px; padding: 2px 6px;">
                    <span class="v-chip__content" style="font-size: 0.65rem;">${codigo}</span>
                  </span>
                  <span class="text-caption grey--text text--darken-2" style="display: inline-flex; align-items: center; gap: 2px; font-size: 0.75rem;">
                    <i class="v-icon notranslate mdi mdi-map-marker-outline theme--light grey--text text--darken-1" style="font-size: 14px;"></i>
                    ${sede}
                  </span>
                </div>
                ${modulo ? `
                <div class="text-caption mt-1 pt-1" style="border-top: 1px dashed #e2e8f0; color: #475569; font-size: 0.8rem; white-space: normal; word-break: break-word;">
                  <span class="primary--text font-weight-bold">M(${moduloNumero})</span> - ${moduloNombre}
                </div>
                ` : ''}
              </div>
            `;
          },
          valueGetter: (params) => {
            const p = params.data?.programa;
            const m = params.data?.programaModulo;
            const programaInfo = p ? `${p.codigo} ${p.nombreCompuesto} ${p.sedeNombre || ''}` : '';
            const moduloInfo = m ? `M(${m.numero}) ${m.moduloNombre || ''}` : '';
            return `${programaInfo} ${moduloInfo}`.trim();
          },
          field: 'programaNombre',
          minWidth: 250,
          maxWidth: 550,
          flex: 1.5,
        },
        {
          headerName: 'Solicitante / Fecha',
          cellRenderer: (params) => {
            const solicitante = params.data?.solicitante;
            const fecha = params.data?.fechaSolicitud;
            if (!solicitante) return 'No tiene información';
            const nombre = solicitante.nombreCompleto || '';
            const ci = solicitante.nroCi || '';
            const fechaFormateada = formatearFechaHoraBolivia(fecha);

            return `
              <div class="d-flex flex-column py-1 w-100" style="line-height: 1.4;">
                <div class="d-flex align-center flex-wrap" style="gap: 6px;">
                  <span class="font-weight-bold text-body-2" style="color: #1e293b; font-size: 0.85rem;">
                    ${nombre}
                  </span>
                  <span class="text-caption font-weight-medium primary--text" style="font-size: 0.75rem;">
                    (${ci})
                  </span>
                </div>
                <div class="text-caption grey--text text--darken-1 mt-1" style="display: inline-flex; align-items: center; gap: 4px; font-size: 0.75rem;">
                  <i class="v-icon notranslate mdi mdi-calendar-clock theme--light grey--text text--darken-1" style="font-size: 14px;"></i>
                  ${fechaFormateada}
                </div>
              </div>
            `;
          },
          valueGetter: (params) => {
            const s = params.data?.solicitante;
            const f = params.data?.fechaSolicitud;
            return s ? `${s.nombreCompleto} ${s.nroCi} ${formatearFechaHoraBolivia(f)}` : '';
          },
          field: 'solicitanteNombre',
          minWidth: 150,
          maxWidth: 300,
          flex: 1.2,
        },
        {
          headerName: 'Revisor',
          cellRenderer: (params) => getRevisor(params.data?.revisandoPor),
          valueGetter: (params) => params.data?.revisandoPor,
          field: 'revisandoPorNombre',
          minWidth: 150,
          maxWidth: 200,
        },
        {
          headerName: 'Observación',
          cellRenderer: (params) => params.data?.observaciones || 'Sin observación',
          valueGetter: (params) => params.data?.observaciones,
          field: 'observaciones',
          minWidth: 150,
          maxWidth: 250,
        },
        {
          headerName: 'Tipo',
          field: 'tipoSolicitud',
          minWidth: 120,
          maxWidth: 150,
        },
        {
          headerName: 'Estado',
          cellRenderer: cellRendererEstadoSolicitud,
          valueGetter: (params) => params.data?.estadoSolicitud,
          minWidth: 100,
          maxWidth: 100,
        },
      ],
    };
  },
  created() {
    this.gridOptions.headerHeight = 48;
    this.gridOptions.floatingFiltersHeight = 38;
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-solicitudes-modificacion {
  height: calc(var(--vh, 1vh) * 100 - 18rem);
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
}

/* Custom CSS variables for Ag-Grid to match reference design */
.ag-theme-balham.ag-grid-listado-solicitudes-modificacion {
  --ag-header-background-color: #f8fafc !important;
  --ag-header-foreground-color: #1e293b !important;
  --ag-header-height: 48px !important;
  --ag-row-hover-color: #f8fafc !important;
  --ag-selected-row-background-color: #eff6ff !important;
  --ag-odd-row-background-color: #ffffff !important;
  --ag-background-color: #ffffff !important;
  --ag-border-color: #e2e8f0 !important;
  --ag-row-border-color: #f1f5f9 !important;
  --ag-font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  --ag-font-size: 13px !important;
  --ag-grid-size: 8px !important;
}

/* Customize headers */
.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .ag-header {
  border-bottom: 2px solid #e2e8f0 !important;
}

.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .ag-header-cell {
  font-weight: 600 !important;
}

.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .ag-header-cell-text {
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  color: #1e293b !important;
  font-size: 0.75rem !important;
}

/* Customize cells and text alignment */
.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .ag-cell {
  display: flex !important;
  align-items: center !important;
  color: #334155 !important;
  border-bottom: 1px solid #f1f5f9 !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  white-space: normal !important;
  word-break: break-word !important;
}

/* Floating filters styled cleanly */
.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .ag-floating-filter {
  background-color: #f8fafc !important;
  border-top: 1px solid #e2e8f0 !important;
}

/* Custom chips inside ag-grid to look like modern badges */
.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .v-chip {
  border-radius: 9999px !important;
  font-size: 0.7rem !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  padding: 4px 10px !important;
  height: 22px !important;
  border-width: 1px !important;
  line-height: 1.25 !important;
  box-shadow: none !important;
}

/* Color-specific overrides for custom chips */
.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .v-chip.primary {
  background-color: #e3f2fd !important;
  border: 1px solid rgba(21, 101, 192, 0.2) !important;
  color: #1565c0 !important;
}

.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .v-chip.orange {
  background-color: #fff3e0 !important;
  border: 1px solid rgba(239, 108, 0, 0.2) !important;
  color: #ef6c00 !important;
}

.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .v-chip.success {
  background-color: #e8f5e9 !important;
  border: 1px solid rgba(46, 125, 50, 0.2) !important;
  color: #2e7d32 !important;
}

.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .v-chip.red {
  background-color: #ffebee !important;
  border: 1px solid rgba(198, 40, 40, 0.2) !important;
  color: #c62828 !important;
}

.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .v-chip.teal {
  background-color: #e0f2f1 !important;
  border: 1px solid rgba(0, 105, 92, 0.2) !important;
  color: #00695c !important;
}

.ag-theme-balham.ag-grid-listado-solicitudes-modificacion .v-chip.grey {
  background-color: #f1f5f9 !important;
  border: 1px solid rgba(100, 116, 139, 0.2) !important;
  color: #475569 !important;
}
</style>

